/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useRef } from "react";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";

function Soatlik({
  setLocations,
  setLabels,
  region,
  district,
  setData,
  data,
  selectedRowKeys,
  setSelectedRowKeys,
  setLoading,
  loading,
}) {
  const conponentPDF = useRef();
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);
  let debounceTimeout;

  const memo = {};

  const filteredValue = (v) => {
    if (memo[v] !== undefined) return memo[v];
    const num = parseFloat(v);
    if (isNaN(num)) return (memo[v] = null);
    const floored = Math.floor(num * 100) / 100;
    return (memo[v] = floored % 1 === 0 ? floored : floored.toFixed(2));
  };

  const sortByVolume = (arr) => {
    if (!Array.isArray(arr)) return [];

    return arr
      .map((item) => {
        const updatedData = item.data.map((point) => {
          const vol = filteredValue(point?.volume);
          return { ...point, volume: vol };
        });

        const volumeCount = updatedData.filter((point) => {
          return point.volume != null;
        }).length;

        return { ...item, data: updatedData, __volumeCount: volumeCount };
      })
      .sort((a, b) => b.__volumeCount - a.__volumeCount)
      .map(({ __volumeCount, ...rest }) => rest);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
            `${getEnv('REACT_APP_BASE_URL')}/v1/republik/proxy/soatlik?sana=${date}&region=${region}&district=${district}`,
            {
                headers: {
                    // O'zingizning tizimingizdagi token (masalan, localStorage'dan olingan)
                    'Authorization': 'Bearer ' + localStorage.getItem('sw_user_token') 
                }
            }
        );

        if (res && res.data) {
          // res.data ichida o'sha-o'sha 'd' va 'l' massivlari keladi
          const sortedData = sortByVolume(res.data.d);
          setData(sortedData);
          setLocations(res.data.l);
        }
      } catch (e) {
        console.log("Xato", e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    setLabels([...Array(24).keys()]);
  }, [date, region, district]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  useEffect(() => {
    if (loading) return;

    const todayCol = document.getElementById("isHours-column");
    if (todayCol) {
      todayCol.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [loading]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");

    let checked = v[0].checked;

    v[0].checked = !checked;

    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const setSearchHandler = (text) => {
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {
      try {
        setLoading(true);

        const searchText = text?.toUpperCase() || "";

        $("tbody tr").each(function () {
          const cell = $(this).children(".fix-with")[0];
          const rowText = cell?.innerText?.toUpperCase() || "";

          if (rowText.includes(searchText)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      } catch (error) {
        console.error("Qidiruvda xatolik:", error);
      } finally {
        setLoading(false);
      }
    }, 500);
  };

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  useEffect(() => {
    if (selectedRowKeys != "") {
      chiz(selectedRowKeys);
    }
  }, [selectedRowKeys]);

  return (
    <div className='table-box'>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearchHandler(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <input
            type='date'
            className='form-control form-control-sm'
            value={ldate}
            onChange={(e) => setLdate(e.target.value)}
          />

          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Aqlli suv soatlik", date, "tblData")}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      {loading ? (
        <LoadingCard heightSize='80vh' loading={loading} />
      ) : (
        <div id='content'>
          <div
            id='tableFlexible'
            style={{ height: selectedRowKeys === "" ? "80vh" : "39vh" }}>
            <div ref={conponentPDF} style={{ width: "100%" }}>
              <table
                id='tblData'
                className='table table-bordered table-style fixedHeader'>
                <thead className=''>
                  <tr>
                    <th rowSpan={2} className='sticky st1'>
                      o
                    </th>

                    <th rowSpan={2} className='sticky' style={{ left: "31px" }}>
                      T/R
                    </th>

                    <th rowSpan={2} className='sticky' style={{ left: "72px" }}>
                      Stantsiya nomi
                    </th>

                    <th colSpan={24}>{date}</th>

                    <th rowSpan={2}>
                      Hajm{" "}
                      <p
                        style={{
                          padding: 0,
                          margin: 0,
                        }}>
                        (ming m³/s)
                      </p>
                    </th>
                  </tr>

                  <tr>
                    {Array(24)
                      .fill()
                      .map((p, i) => {
                        return <th key={i}>{i < 9 ? "0" + (i + 1) : i + 1}</th>;
                      })}
                  </tr>
                </thead>

                <tbody>
                  {data.length > 0
                    ? data.map((d, index) => {
                        return (
                          <tr key={index} className={"tr" + index}>
                            <td className='sticky st1'>
                              <input type='checkbox' />
                            </td>

                            <td
                              onClick={() => chiz(index)}
                              className='sticky'
                              style={{ left: "31px" }}>
                              {index + 1}
                            </td>

                            <td
                              onClick={() => chiz(index)}
                              className='text-start sticky fix-with'
                              style={{ left: "72px" }}>
                              {d.name}
                            </td>

                            {Array(24)
                              .fill()
                              .map((_, i) => {
                                const isHour = i === new Date().getHours();

                                return (
                                  <td
                                    onClick={() => chiz(index)}
                                    id={isHour ? "isHours-column" : undefined}
                                    style={{
                                      width: 70,
                                      minWidth: 70,
                                      maxWidth: 70,
                                    }}
                                    key={i}>
                                    {d.data
                                      ? d.data[i]
                                        ? d.data[i].volume
                                        : ""
                                      : ""}
                                  </td>
                                );
                              })}

                            <td
                              style={{
                                width: 100,
                                minWidth: 100,
                                maxWidth: 100,
                              }}>
                              {d?.obyom}
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Soatlik;

const summValue = (d) => {
  if (!d?.data || !Array.isArray(d.data)) return 0;

  return d.data.reduce((sum, el) => sum + Number(el?.volume || 0), 0);
};
